module.exports = __webpack_public_path__ + "img/siterra.d18f6a64.png";